export const MAX_IMPORT_BYTES = 5 * 1024 * 1024;
export const MAX_PREVIEW_ROWS = 5000;
export const PREVIEW_PAGE_SIZE = 50;
export const MAX_CLIENT_DUPLICATE_CHECK = 20000;

export const IMPORT_FILE_EXTENSIONS = ['.csv', '.tsv', '.txt', '.json'];

export const CODE_ALIASES = [
  'code', 'assettypecode', 'sku', 'upc', 'gtin', 'item', 'itemcode',
  'part', 'partnumber', 'partno',
];

export const DESCRIPTION_ALIASES = [
  'description', 'assettypedescription', 'desc', 'name',
  'itemdescription', 'productdescription',
];

export const IGNORED_HEADERS = ['id', 'tenant', 'key'];

export const PROPERTY_PREFIXES = ['assettype.properties.', 'properties.', 'property.'];

export const ASSET_TYPE_PREFIX = 'assettype.';
